/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineDetailModel,
    MachineDetailModelFromJSON,
    MachineDetailModelFromJSONTyped,
    MachineDetailModelToJSON,
} from './MachineDetailModel';

/**
 * 
 * @export
 * @interface MachineDetailModelPagedDataModel
 */
export interface MachineDetailModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<MachineDetailModel>}
     * @memberof MachineDetailModelPagedDataModel
     */
    data?: Array<MachineDetailModel> | null;
}

export function MachineDetailModelPagedDataModelFromJSON(json: any): MachineDetailModelPagedDataModel {
    return MachineDetailModelPagedDataModelFromJSONTyped(json, false);
}

export function MachineDetailModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineDetailModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(MachineDetailModelFromJSON)),
    };
}

export function MachineDetailModelPagedDataModelToJSON(value?: MachineDetailModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(MachineDetailModelToJSON)),
    };
}

